var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "meeting-embed",
      style: "--width: " + _vm.$vuetify.breakpoint.width * 0.8 + "px"
    },
    [
      _c("div", { staticClass: "meeting-embed__header" }, [
        _c("div", { staticClass: "meeting-embed__identity" }, [
          _c(
            "span",
            { staticClass: "meeting-embed__icon" },
            [_c("portal-icon", { attrs: { name: "calendar-days", size: 19 } })],
            1
          ),
          _c("span", [_vm._v(_vm._s(_vm.$t("meetings.schedule.heading")))])
        ]),
        _c(
          "button",
          {
            attrs: { type: "button", "aria-label": _vm.$t("global.close") },
            on: {
              click: function($event) {
                return _vm.$emit("result")
              }
            }
          },
          [_c("portal-icon", { attrs: { name: "x", size: 20 } })],
          1
        )
      ]),
      _c("div", { staticClass: "meeting-embed__body" }, [
        _c("iframe", {
          staticClass: "responsive-iframe",
          attrs: { src: _vm.finalUrl, id: "frame-" + _vm.frameId }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }